import { Record } from 'immutable';

const keys: LegalDocumentType = {
  id: '',
  name: '',
  url: '',
  languageTranslationKey: '',
  languageCode: '',
  default: false,
};

export interface LegalDocumentType {
  id: string;
  name: string;
  url: string;
  languageTranslationKey: string;
  languageCode: string;
  default: boolean;
}

export default class LegalDocumentRecord extends Record<LegalDocumentType>(
  keys
) {}
